import {createStore} from 'vuex'

export default createStore({
    state: {
        bottomBarNum:JSON.parse(sessionStorage.getItem("bottomBarNum")) || 0,
        ordermsg:JSON.parse(localStorage.getItem("orderData")) || null,
        userData:localStorage.getItem("userData2")||null,
        userDataC:localStorage.getItem("userData2C")||null,
        themeColor:sessionStorage.getItem("sessionThemeC")||0,
        camarass:'auto',
        pagewidth:JSON.parse(sessionStorage.getItem("pagewidth")) ||0,
        PCResturantID:sessionStorage.getItem("PCRTid")||null,
        PCTableNO:sessionStorage.getItem("PCNO")||null,
        PCshoppingcartNum:0
    },
    mutations: {
        sweichTab(state,bottomBarNum) {
            state.bottomBarNum = bottomBarNum;
            sessionStorage.setItem("bottomBarNum", JSON.stringify(bottomBarNum))
        },
        orderMsg(state,order){
            state.ordermsg=order;
            if(order){
                localStorage.setItem("orderData", JSON.stringify(order));
                localStorage.setItem("orderData_time",+new Date());
            }else{
                localStorage.removeItem("orderData");
                localStorage.removeItem("orderData_time");
            }
        },
        setuser(state,userData){
            if(userData){
                state.userData=JSON.stringify(userData);
                localStorage.setItem("userData2", JSON.stringify(userData))
            }else{
                state.userData=null;
                localStorage.removeItem("userData2");
            }
        },
        setuserC(state,userDataC){
            if(userDataC){
                state.userDataC=JSON.stringify(userDataC);
                localStorage.setItem("userData2C", JSON.stringify(userDataC))
            }else{
                state.userDataC=null;
                localStorage.removeItem("userData2C");
            }
        },
        changeThmeme(state,colorA){
            state.themeColor=colorA;
            sessionStorage.setItem("sessionThemeC",colorA)
        },
        changecamara(state,cama){
            state.camarass=cama;
        },
        changepagewidth(state,num){
            state.pagewidth=num;
            sessionStorage.setItem("pagewidth", num);
        },
        changePCRTid(state,id){
            state.PCResturantID=id;
            sessionStorage.setItem("PCRTid", id);
        },
        changePCNO(state,num){
            state.PCTableNO=num;
            sessionStorage.setItem("PCNO", num);
        },
        PCchangeAllfood(state,num){
            state.PCshoppingcartNum=num;
            sessionStorage.setItem("PCSessonAllfoodNum",num);
        }
    },
    actions: {},
    modules: {}
})